<template>
  <div ref="root" class="bg-gradient-to-r from-[#510F23] to-[#D85753]">
    <div :style="backgroundStyle">
      <div class="container min-h-7 py-1.5 3xl:max-w-[1788px]">
        <Swiper
          v-if="topPromotion?.slides?.length"
          :autoplay="{
            delay: 10000,
            disableOnInteraction: false,
          }"
          :modules="modules"
          :loop="true"
          aria-label="Top Promo Info"
          :slides-per-view="1"
          :space-between="5"
        >
          <SwiperSlide v-for="item in topPromotion.slides" :key="item.id">
            <div
              class="select-none text-center text-xs text-white"
              @click="contentClick"
              v-html="item.text"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper";
import { useGeneralInternalStore } from "~/stores/generalInternal";

const { topPromotion } = useGeneralInternalStore();
const modules = [Autoplay];

const root = ref();

const isVisibleDiscountCompaign = useElementVisibility(root);

const contentClick = useContentLink;

const { height } = useElementBounding(root);

const backgroundStyle = computed(() => {
  return {
    backgroundColor: topPromotion?.backgroundColor?.hexa || "transparent",
  };
});

watch(height, () => {
  setCustomProperty("--discount-compaign-height", String(`${height.value}px`));
});

watch(isVisibleDiscountCompaign, () => {
  setCustomProperty(
    "--discount-compaign-visible-height",
    String(isVisibleDiscountCompaign.value ? `${height.value}px` : "0px"),
  );
});
</script>
